// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-preferences_wrapper__ieHrO {
  max-width: 600px;
}

.team-preferences_icon__se8wc {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: var(--white-text-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

.team-preferences_header__MHqmx {
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 12px;
  align-items: center;
}

.team-preferences_title__9wOuk {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-preferences_title-wrapper__2GrYt {
  display: flex;
  align-items: center;
  gap: 4px;
}

.team-preferences_container__cRHL- {
  background-color: var(--primary-background-color);
  padding: 24px;
  border-radius: 4px;
  border: 1px solid var(--primary-border-color);
  height: inherit;
  display: flex;
  gap: 24px;
  flex-direction: column;
}

.team-preferences_form__ZAC1g {
  display: flex;
  gap: 24px;
  flex-direction: column;
}

.team-preferences_actions__sYEzw {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  align-items: center;
}

.team-preferences_error__r55be {
  border: 1px solid var(--error-text-color);
}

.team-preferences_errorMessage__nfmjE {
  color: var(--error-text-color);
}

@media (max-width: 768px) {
  .team-preferences_wrapper__ieHrO {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/teams/team-preferences.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".wrapper {\n  max-width: 600px;\n}\n\n.icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  background-color: var(--white-text-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header {\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  gap: 12px;\n  align-items: center;\n}\n\n.title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.container {\n  background-color: var(--primary-background-color);\n  padding: 24px;\n  border-radius: 4px;\n  border: 1px solid var(--primary-border-color);\n  height: inherit;\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n}\n\n.form {\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  align-items: center;\n}\n\n.error {\n  border: 1px solid var(--error-text-color);\n}\n\n.errorMessage {\n  color: var(--error-text-color);\n}\n\n@media (max-width: 768px) {\n  .wrapper {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `team-preferences_wrapper__ieHrO`,
	"icon": `team-preferences_icon__se8wc`,
	"header": `team-preferences_header__MHqmx`,
	"title": `team-preferences_title__9wOuk`,
	"title-wrapper": `team-preferences_title-wrapper__2GrYt`,
	"container": `team-preferences_container__cRHL-`,
	"form": `team-preferences_form__ZAC1g`,
	"actions": `team-preferences_actions__sYEzw`,
	"error": `team-preferences_error__r55be`,
	"errorMessage": `team-preferences_errorMessage__nfmjE`
};
export default ___CSS_LOADER_EXPORT___;
